// extracted by mini-css-extract-plugin
export default {"faqItem":"FAQItem_faqItem__5R9P7","number":"FAQItem_number__s8rqS","question":"FAQItem_question__dBc+q","toggle":"FAQItem_toggle__NidMy","answer":"FAQItem_answer__Cr0sD"};